export default __webpack_public_path__ + "static/media/thumbnail.74897169.webp";